export default {
  title: 'Conditioning Kit',
  id: 'fightcamp_conditioning_kit_deal',
  price: 0,
  oldPrice: 15900,
  category: 'accessory',
  description: '',
  img_url: '',
  fbid: '',
  types: ['Bundles'],
};
